import React from 'react';
import styles from './footer.module.css';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <motion.footer
      className={styles.footer}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className={styles.inner}>
        <div className={styles.column}>
          <h2 className={styles.companyName}>GeoGlobalGate LTD</h2>
          <p className={styles.idNumber}>
            <span className={styles.label}>ს/კ:</span> 404598823
          </p>
          <p className={styles.address}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            ქ. ბორჯომი, შოთა რუსთაველის ქ. N109
          </p>
        </div>

        <div className={styles.column}>
          <h3 className={styles.sectionTitle}>{t('navContact')}</h3>
          <a className={styles.item} href="tel:+995500703003">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.65 3.48 2 2 0 0 1 3.62 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.96a16 16 0 0 0 6 6l.96-1.76a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.01z"></path>
            </svg>
            +995 500 703 003
          </a>
          <a className={styles.item} href="tel:+995599353888">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.65 3.48 2 2 0 0 1 3.62 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.96a16 16 0 0 0 6 6l.96-1.76a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.01z"></path>
            </svg>
            +995 599 353 888
          </a>
          <a className={styles.item} href="mailto:t1@geoglobalgate.com">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            t1@geoglobalgate.com
          </a>
          <a className={styles.item} href="mailto:geoglobalgate@gmail.com">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            geoglobalgate@gmail.com
          </a>
        </div>

        <div className={styles.column}>
          <h3 className={styles.sectionTitle}>More Information</h3>
          <Link className={styles.item} to="news" smooth={true} duration={500} offset={-80} style={{cursor:'pointer'}}>
            News
          </Link>
          <a className={styles.item} href="/customer-service">
            Customer Service
          </a>
          <a className={styles.item} href="/career">
            Career
          </a>
          <a
            className={styles.item}
            href="https://www.rs.ge/NCTSInfo?cat=5&tab=1"
            target="_blank"
            rel="noopener noreferrer"
          >
            Revenue Service — NCTS
          </a>
        </div>

        <div className={styles.column}>
          <h3 className={styles.sectionTitle}>{t('footerFollowUs')}</h3>
          <a
            className={styles.item}
            href="https://www.linkedin.com/company/geoglobalgate-ltd/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
              <rect x="2" y="9" width="4" height="12"></rect>
              <circle cx="4" cy="4" r="2"></circle>
            </svg>
            LinkedIn — GeoGlobalGate LTD
          </a>
          <a
            className={styles.item}
            href="https://www.google.com/maps/place//data=!4m3!3m2!1s0x88188d486f69fb41:0x4926a8aeb9a838bb!12e1?source=g.page.m.ia._&laa=nmx-review-solicitation-ia2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
            GeoGlobalGate — Google Review
          </a>
          <a
            className={styles.item}
            href="https://www.instagram.com/geoglobalgateltd"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
            </svg>
            Instagram — GeoGlobalGate
          </a>
          <a
            className={styles.item}
            href="https://www.facebook.com/share/14bJxfmqqx3/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
            </svg>
            Facebook — GeoGlobalGate
          </a>
        </div>
      </div>

      <div className={styles.rights}>
        {t('footerRights')}
      </div>
    </motion.footer>
  );
};

export default Footer;
